import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useMutation } from "react-query";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";

import { useAuth } from "../../hooks/useAuth";
import { fetchActionsUtil } from "../../utils/helpers";
const SchemeModal = ({ show, onHide, onSuccess, schemeData }) => {
  const { backendUrl, token } = useAuth();

  const uploadForm = useFormik({
    initialValues: {
      title: schemeData?.title || "",
      description: schemeData?.description || "",
    },
    validationSchema: yup.object().shape({
      title: yup.string().required("Title is required"),
    }),
    onSubmit: async (values) => {
      const payload = {
        title: values.title,
        description: values.description,
      };

      saveScheme.mutate(payload);
    },
  });

  const saveScheme = useMutation(
    (payload) => {
      const endpoint = schemeData?.id ? "update-scheme" : "save-scheme";
      return fetchActionsUtil(
        `${backendUrl}/api/warehouse/${endpoint}`,
        "POST",
        token,
        schemeData?.id ? { ...payload, id: schemeData.id } : payload,
      );
    },
    {
      onSuccess: (data) => {
        toast.success(data?.message || "Saved successfully");
        uploadForm.resetForm();
        onSuccess?.();
        onHide();
      },
      onError: (error) => {
        toast.error(error?.message || "Failed to save");
      },
    },
  );

  const handleClose = () => {
    uploadForm.resetForm();
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="md">
      <Modal.Header closeButton>
        <Modal.Title as={"h6"}>Scheme</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={uploadForm.handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter title"
              name="title"
              value={uploadForm.values.title}
              onChange={uploadForm.handleChange}
              onBlur={uploadForm.handleBlur}
              isInvalid={
                uploadForm.touched.title && Boolean(uploadForm.errors.title)
              }
            />

            <Form.Control.Feedback type="invalid">
              {uploadForm.errors.title}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              placeholder="Enter description"
              value={uploadForm.values.description}
              onChange={uploadForm.handleChange}
              onBlur={uploadForm.handleBlur}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
          disabled={saveScheme.isLoading}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={uploadForm.handleSubmit}
          disabled={saveScheme.isLoading}
        >
          {saveScheme.isLoading ? "Saving..." : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SchemeModal;
